import {Component, Input, OnInit}                  from '@angular/core';
import {ModalController, NavController}            from '@ionic/angular';
import {APIService, PermissionType, User}          from 'src/app/API.service';
import {Router}                                    from '@angular/router';
import {SessionService}                            from '../../../services/session.service';
import {DataStore, SortDirection}                  from '@aws-amplify/datastore';
import {Contract, Notification, User as UserModel} from '../../../../models';
import {ContractStatus, Percentages}               from '../../../enums/enums';
import {AgentService}                              from '../../../services/agent.service';
import {
    ExtendContractModalComponent
}                                                  from '../../administrator/extend-contract-modal/extend-contract-modal.component';
import {ModalService}                              from "../../../services/modal.service";
import {NotificationService}                       from "../../../services/notification.service";
import {DateTime}                                  from "luxon";
import {environment}                               from "../../../../environments/environment";

@Component({
    selector: 'app-contracts-list',
    templateUrl: './contracts.component.html',
    styleUrls: ['./contracts.component.scss'],
})
export class ContractsComponent implements OnInit {
    @Input() owner: User;
    @Input() type: string = 'contract';

    filteredContractList: Contract[] = [];
    utenti = [];
    contractsList: Contract[] = [];
    cssClass: string = 'asd';
    p;
    contractStatus = ContractStatus;
    private filters: any;


    constructor(
            public notification: NotificationService,
            public navController: NavController,
            private modalService: ModalService,
            public apiService: APIService,
            public sessionService: SessionService,
            public router: Router,
            public modalController: ModalController,
            private agentService: AgentService,
    ) {
    }

    async ngOnInit() {
        this.p = Percentages;
        this.refreshContractList();
    }

    private async refreshContractList() {
        // const currentUser = this.sessionService.getCurrentUser();
        // this.contractsList =  await (await DataStore.query(Contract)).filter(c => { return c.userID == this.sessionService.user?.id });
        const contracts = await DataStore.query(Contract);
        

        // let's filter all if no owner is specified
        let filter = c => {
            return true;
        };
        if (this.owner) {
            filter = c => {
                return c.commercial?.id == this.owner?.id;
                //   return c.commercial.id == this.owner.id;
            };

            if (this.owner.permessions == 'CLIENT' || this.type == 'investment') {
                filter = c => {
                    return c.userID == this.owner.id;
                };
            }
        }

        this.contractsList = this.filteredContractList = contracts.filter(filter).sort((a, b) =>
                (a.startDate?.localeCompare(b.startDate)));
        this.contractsList = this.filteredContractList = contracts.filter(filter).sort((a, b) =>
                (a.status == ContractStatus.ACTIVE ? 1 : -1));


        for (let c of this.contractsList) {
            this.utenti[c.id] = await DataStore.query(UserModel, c.clientId);
        }
        if (this.filters)
            this.filterContracts(this.filters);

    }


// @todo
    openContract(contractId: string) {
        this.cssClass = '';
        this.router.navigate(['/contract', contractId]);
    }

    editContract(contractId: string) {
        this.openEditContractModal(contractId);
    }

    addContract() {
        this.openEditContractModal(null);
    }

    private async openEditContractModal(contractId: any) {
        this.modalService.contractEdit(contractId, this.owner).then(async d => {
            await this.refreshContractList();
        });

    }

    async deleteContract(contractId: string) {
        this.cssClass = '';

        if (confirm('Sicuro di voler cancellare il contratto')) {
            await DataStore.delete(Contract, contractId);
            // let the animation finish its job
            setTimeout(() => {
                this.refreshContractList();
            }, 1000);
        }
    }

    async filterContracts(filters) {
        this.filters = filters;
        

        if (filters['name'].trim().length == 0) {
            this.filteredContractList = this.contractsList;
        }

        this.filteredContractList = this.contractsList.filter(u => {
            let matcheNames = '.+';
            let matcheStatus = true;

            if (filters['name']?.trim().length != 0)
                matcheNames = filters['name'];
            else return true;
            const reName = new RegExp(matcheNames?.toLocaleLowerCase(), 'gi');

            // if (filters['status'] != 'Tutti') {
            //     matcheStatus = u.status == filters['status']
            // }

            // make sure we don't take into account users with no name
            // if(!u.userContractsAddedId || !u.commercial.lastname || !u.status) return false;

            // const bonusUser = await (await DataStore.query(User, user => user.id("eq", u.userID)))[0];
            let x = `${u.commercial?.name?.toLocaleLowerCase()} ${u.commercial?.lastname?.toLocaleLowerCase()}   ${this.utenti[u.id]?.name?.toLocaleLowerCase()} ${this.utenti[u.id]?.lastname?.toLocaleLowerCase()}`.match(reName);
            


            return x;
            // return `${bonusUser.name} ${bonusUser.lastname}`.match(reName) && matcheStatus;
        });
        

        this.filteredContractList = this.filteredContractList.sort((a, b) => {
            if (filters.filterBy == 'amount')
                if (filters.sort == SortDirection.ASCENDING) {
                    return a.amount - b.amount;
                } else {
                    return b.amount - a.amount;
                }
            if (filters.sort == SortDirection.ASCENDING) {
                if (filters.filterBy == '_lastChangedAt')
                    return a[filters.filterBy] - b[filters.filterBy];
                return a[filters.filterBy]?.toString().localeCompare(b[filters.filterBy]?.toString());
            } else {
                if (filters.filterBy == '_lastChangedAt')
                    return b[filters.filterBy] - a[filters.filterBy];
                return b[filters.filterBy]?.toString().localeCompare(a[filters.filterBy]?.toString());
            }
        });
        
    }

    async active(contract: Contract) {


        await this.agentService.activeContract(contract);
        contract = await DataStore.save(Contract.copyOf(contract, u => {
            u.status = ContractStatus.ACTIVE;
        }));
        await this.refreshContractList();
    }

    async changeStatus(contract: Contract, status) {
        if (status == ContractStatus.ACTIVE) {
            await this.active(contract);
        } else {
            contract = await DataStore.save(Contract.copyOf(contract, u => {
                u.status = status;
            }));
        }
        await this.refreshContractList();
        switch (status) {
            case  "DRAFT":

                break;
            case  "TOVERIFY":
                if (this.sessionService.user?.permessions == PermissionType.COMMERCIAL) {
                    let msg = this.msgReplace(environment.notificatiosn.amministratore.Contratto_da_verificare, contract.clientId);
                    await this.notification.notifyAdmin(msg, '/contract/' + contract.id);
                }

                break;
            case  "TOBEPAYED":
                if (this.sessionService.user?.permessions == PermissionType.ADMINISTRATOR) {
                    const msg = this.msgReplace(environment.notificatiosn.commerciale.Contratto_Verificato, contract.clientId);
                    await this.notification.notifyCommercial(msg, contract.commercial?.id, '/contract/' + contract.id);
                }

                break;
            case  "PAYED":
                if (this.sessionService.user?.permessions == PermissionType.COMMERCIAL) {

                    const msg = environment.notificatiosn.amministratore.Contratto_Bonificato;
                    await this.notification.notifyAdmin(msg, '/contract/' + contract.id);
                }

                break;
            case  "ACTIVE":
                const msgCommercial = this.msgReplace(environment.notificatiosn.commerciale.CONTRATTO_ATTIVO, contract.clientId);
                await this.notification.notifyCommercial(msgCommercial, contract.commercial?.id, '/contract/' + contract.id);
                await this.notification.notifyCLient(this.msgReplace(environment.notificatiosn.commerciale.Contratto_scaduto, contract.clientId), contract.clientId, '/contract/' + contract.id, contract.endDate);

                const msgClient = environment.notificatiosn.client.CONTRATTO_ATTIVO;
                await this.notification.notifyCLient(msgClient, contract.clientId, '/contract/' + contract.id);
                await this.notification.notifyCLient(environment.notificatiosn.client.Contratto_scaduto, contract.clientId, '/contract/' + contract.id, contract.endDate);
                break;

        }


    }

    proroga(id: string) {
        this.openExtendedContractModal(id);
    }

    private async openExtendedContractModal(contractId: any) {
        const modal = await this.modalController.create({
            component: ExtendContractModalComponent,
            componentProps: {contractId: contractId},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            this.refreshContractList();
        });
    }

    async msgReplace(msg, clientId) {
        const client = await DataStore.query(UserModel, clientId);
        msg = msg.replace('[NOME]', client?.name)
        msg = msg.replace('[COGNOME]', client?.lastname)
        return msg;
    }

}
